import React from 'react';
import { Heart } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  return <section className="pt-16 pb-20 px-4 md:px-8 max-w-4xl mx-auto text-center" data-id="element-25">
      <div className="flex justify-center mb-6" data-id="element-26">
        <div className="bg-brand-peach/20 p-4 rounded-full" data-id="element-27">
          <Heart className="w-10 h-10 text-brand-peachDark fill-current" data-id="element-28" />
        </div>
      </div>

      <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-brand-textDark leading-tight mb-8" data-id="element-29">
        ¿Sientes que amas a tu hijo con todo tu corazón… pero algunos días
        simplemente{' '}
        <span className="text-brand-peachDark" data-id="element-30">
          no sabes cómo manejar las rabietas
        </span>
        , los gritos o los límites?
      </h1>

      <div className="mb-10" data-id="element-31">
        <img src="https://cdn.magicpatterns.com/uploads/sas3MgHimgYbzigVDJDTi2/2914c63f-e848-4360-84ad-f855d3e7c7bd.png" alt="Madre sonriendo mientras muestra el libro Mega Pack Crianza con Calma y su versión digital en el teléfono" className="w-full max-w-2xl mx-auto rounded-3xl shadow-xl" data-id="element-32" />
      </div>

      <p className="text-lg md:text-xl text-brand-text max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-33">
        Descubre el método que ya está ayudando a cientos de familias a educar
        con más calma, conexión y seguridad,{' '}
        <strong className="text-brand-textDark font-semibold" data-id="element-34">
          sin recurrir a los gritos ni a los castigos.
        </strong>
      </p>

      <Button href="https://mega-pack-crianza-con-calma.impultienda.ar/checkout" data-id="element-35">
        Quiero el Mega Pack Crianza con Calma
      </Button>
    </section>;
}